import { Loader2 } from "lucide-react";
import { forwardRef } from "react";

interface LoadingSpinnerProps {
  className?: string;
}

const LoadingSpinner = forwardRef<HTMLSpanElement, LoadingSpinnerProps>(
  ({ className }, ref) => {
    return (
      <div className="flex justify-center px-6 py-4">
        <span ref={ref}>
          <Loader2
            className={`animate-spin dark:text-white ${className || ""}`}
          />
        </span>
      </div>
    );
  }
);

export default LoadingSpinner;
